import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "self-center full-width no-outline"
}
const _hoisted_2 = { class: "text-caption" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Use the \"Pick Member\" button to add existing or new member ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_field = _resolveComponent("q-field")!

  return (_openBlock(), _createBlock(_component_q_field, {
    "model-value": _ctx.modelValue,
    "bottom-slots": "",
    label: _ctx.label+'*',
    "stack-label": "",
    readonly: "",
    outlined: "",
    dense: "",
    rules: [_ctx.requiredRule]
  }, _createSlots({
    control: _withCtx(() => [
      (_ctx.modelValue !== '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.firstName) + " " + _toDisplayString(_ctx.lastName) + " ", 1),
            _createElementVNode("span", _hoisted_2, "( " + _toDisplayString(_ctx.modelValue) + " )", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_ctx.showHint)
      ? {
          name: "hint",
          fn: _withCtx(() => [
            _hoisted_3
          ])
        }
      : undefined,
    (_ctx.showPickMemberButton)
      ? {
          name: "after",
          fn: _withCtx(() => [
            (!_ctx.modelValue)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  label: "Pick Member",
                  color: "primary",
                  unelevated: "",
                  "no-caps": "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showMemberDialog')))
                }))
              : (_openBlock(), _createBlock(_component_q_btn, {
                  key: 1,
                  label: "Change Member",
                  color: "primary",
                  unelevated: "",
                  "no-caps": "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showMemberDialog')))
                }))
          ])
        }
      : undefined
  ]), 1032, ["model-value", "label", "rules"]))
}